<template>
  <div
    class="evaluation-overview-layout-symbol"
    :style="{
      'grid-template-columns': layout.templateColumns,
      'grid-template-rows': layout.templateRows,
      'grid-template-areas': layout.templateAreas
    }"
  >
    <div
      v-for="tile in layout.tiles"
      :key="tile"
      class="evaluation-overview-layout-symbol__tile"
      :style="`grid-area: a${tile}`"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import {
  overviewLayouts,
  useEvaluationOverviewStore
} from "./evaluationOverviews.store";

const props = defineProps<{
  overviewId: number;
}>();

const layout = computed(() => {
  const overview = useEvaluationOverviewStore().items[props.overviewId];
  return overviewLayouts[overview.layout];
});
</script>

<style lang="scss">
.evaluation-overview-layout-symbol {
  width: 1.2rem;
  height: 1rem;
  flex-shrink: 0;
  display: inline-grid;
  gap: 1px;
  padding: 1px;
  background-color: rgba(0, 0, 0, 0.025);
  vertical-align: middle;
  margin-right: 4px;
  margin-top: -2px;

  &__tile {
    background-color: var(--color-grey-dark);
    height: 100%;
    width: 100%;
    min-height: 0;
  }
}
</style>
